var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z",
    fill: "url(#instagram_svg__paint0_linear_427_109501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.764 31.34a6.236 6.236 0 003.569-3.57c.3-.776.51-1.662.566-2.958.014-.304.024-.559.034-.814v-8.66c-.007-.18-.014-.368-.024-.58-.057-1.296-.267-2.186-.567-2.959a5.952 5.952 0 00-1.41-2.162 5.99 5.99 0 00-2.159-1.406c-.776-.3-1.662-.51-2.958-.566-1.306-.063-1.72-.077-5.032-.077-3.31 0-3.726.014-5.026.071-1.296.057-2.187.267-2.96.567-.818.31-1.552.786-2.162 1.41-.62.611-1.1 1.35-1.406 2.159-.3.777-.51 1.662-.567 2.959-.062 1.305-.076 1.72-.076 5.032 0 3.311.014 3.726.071 5.026.057 1.296.267 2.188.568 2.96.31.819.79 1.552 1.41 2.163a5.999 5.999 0 002.158 1.405c.777.3 1.663.51 2.96.567 1.3.057 1.714.072 5.026.072s3.726-.015 5.027-.072c1.296-.057 2.186-.267 2.959-.567h-.001zm-7.976-1.554c-3.255 0-3.645-.014-4.927-.071-1.191-.053-1.835-.253-2.263-.42a3.766 3.766 0 01-1.401-.91 3.786 3.786 0 01-.91-1.4c-.167-.429-.367-1.077-.42-2.263-.056-1.287-.07-1.673-.07-4.927 0-3.255.014-3.646.07-4.927.053-1.19.253-1.834.42-2.263.195-.529.505-1.01.915-1.4a3.794 3.794 0 011.4-.91c.429-.167 1.077-.367 2.263-.42 1.287-.057 1.673-.071 4.927-.071 3.254 0 3.645.014 4.927.071 1.19.053 1.834.253 2.263.42.528.195 1.01.504 1.4.91.405.395.715.871.91 1.4.167.429.367 1.077.42 2.263.056 1.287.07 1.673.07 4.927 0 3.254-.014 3.635-.07 4.921-.053 1.192-.253 1.835-.42 2.264a4.045 4.045 0 01-2.315 2.315c-.43.166-1.077.367-2.263.42-1.287.056-1.673.07-4.927.07l.001.001z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.782 13.519a6.267 6.267 0 00-6.266 6.266 6.267 6.267 0 106.266-6.266zm0 10.33a4.065 4.065 0 110-8.13 4.065 4.065 0 010 8.13zM27.762 13.272a1.463 1.463 0 10-2.926 0 1.463 1.463 0 002.926 0z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint0_linear_427_109501",
    x1: 20,
    y1: -1.246,
    x2: 20,
    y2: 42.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E82D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A22DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643DCE"
  })))));
}

export default SvgInstagram;